import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1d16cc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body py-5" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = {
  value: "",
  disabled: ""
}
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 1,
  class: "py-2 text-muted"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin me-2" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "row g-5"
}
const _hoisted_11 = { class: "col-lg-9" }
const _hoisted_12 = { class: "card mb-5" }
const _hoisted_13 = { class: "card-header" }
const _hoisted_14 = { class: "card-title" }
const _hoisted_15 = { class: "card-body p-9" }
const _hoisted_16 = { class: "fv-row mb-7" }
const _hoisted_17 = { class: "fw-bold fs-6 mb-2" }
const _hoisted_18 = { class: "fv-row mb-7 editor-container" }
const _hoisted_19 = { class: "fw-bold fs-6 mb-2" }
const _hoisted_20 = { class: "fv-row mb-0" }
const _hoisted_21 = { class: "fw-bold fs-6 mb-2" }
const _hoisted_22 = { class: "col-lg-3" }
const _hoisted_23 = { class: "sticky-sidebar" }
const _hoisted_24 = { class: "card shadow-sm" }
const _hoisted_25 = { class: "card-header px-5 py-3 min-h-auto" }
const _hoisted_26 = { class: "card-title fs-6 fw-bolder" }
const _hoisted_27 = { class: "card-body p-5" }
const _hoisted_28 = {
  key: 0,
  class: "d-flex flex-column gap-2"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["textContent"]
const _hoisted_31 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, null, {
    actions: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.handleSave,
        loading: _ctx.guardando,
        disabled: !_ctx.selectedId
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.guardar")), 1)
        ]),
        _: 1
      }, 8, ["onClick", "loading", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("page.website.plantillasEmail.seleccionar")), 1),
            _createElementVNode("div", _hoisted_5, [
              (!_ctx.cargando)
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 0,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedId) = $event)),
                    class: "form-select form-select-solid",
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadTemplate && _ctx.loadTemplate(...args)))
                  }, [
                    _createElementVNode("option", _hoisted_6, _toDisplayString(_ctx.$t("page.website.plantillasEmail.seleccionaUna")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listaLocal, (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: item.id,
                        value: String(item.id)
                      }, _toDisplayString(item.nombre), 9, _hoisted_7))
                    }), 128))
                  ], 544)), [
                    [_vModelSelect, _ctx.selectedId]
                  ])
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("page.website.plantillasEmail.cargando")), 1)
                  ]))
            ])
          ])
        ])
      ]),
      (_ctx.selectedId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.form.nombre), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("page.website.plantillasEmail.asunto")), 1),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.asunto,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.asunto) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("page.website.plantillasEmail.cuerpoHtml")), 1),
                    _createVNode(_component_QuillEditor, {
                      theme: "snow",
                      content: _ctx.form.cuerpoHtml,
                      "onUpdate:content": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.cuerpoHtml) = $event)),
                      contentType: "html"
                    }, null, 8, ["content"])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("page.website.plantillasEmail.cuerpoTexto")), 1),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.cuerpoTexto,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.cuerpoTexto) = $event)),
                      type: "textarea",
                      rows: 8
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("h3", _hoisted_26, _toDisplayString(_ctx.$t("page.website.plantillasEmail.variablesDisponibles")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    (_ctx.form.variables && _ctx.form.variables.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.variables, (v) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: v.tag,
                              class: "variable-item",
                              onClick: ($event: any) => (_ctx.copyTag(v.tag))
                            }, [
                              _createElementVNode("code", {
                                textContent: _toDisplayString('{{ ' + v.tag + ' }}')
                              }, null, 8, _hoisted_30),
                              _createElementVNode("small", _hoisted_31, _toDisplayString(v.ayuda), 1)
                            ], 8, _hoisted_29))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}